import React from "react";
import "./RedeemHistory.css";

import { useNavigate } from "react-router-dom";
import amazonLogo from "../assets/amazon.png";
import flipkartLogo from "../assets/flipkart.png";
import lenskartLogo from "../assets/Lenskart.png";
import boatLogo from "../assets/boat.png";
import mamaearthLogo from "../assets/mamaearth.png";

interface Deal {
  id: number;
  image: string;
  title: string;
  cost: number;
}

interface HistoryItem {
  brand: string;
  logo: string;
  date: string;
  time: string;
  points: number;
}

const redeemedDeals: Deal[] = [
  {
    id: 1,
    image: mamaearthLogo,
    title: "Mama Earth ₹300 off coupon",
    cost: 2500,
  },
  { id: 2, image: lenskartLogo, title: "Lenskart ₹300 off coupon", cost: 2500 },
  { id: 3, image: boatLogo, title: "Boat ₹300 off coupon", cost: 2500 },
  { id: 4, image: amazonLogo, title: "Amazon ₹250 gift card", cost: 2500 },
  { id: 5, image: flipkartLogo, title: "Flipkart ₹150 gift card", cost: 2500 },
  {
    id: 6,
    image: mamaearthLogo,
    title: "Mama Earth ₹300 off coupon",
    cost: 2500,
  },
  { id: 7, image: lenskartLogo, title: "Lenskart ₹300 off coupon", cost: 2500 },
  { id: 8, image: boatLogo, title: "Boat ₹300 off coupon", cost: 2500 },
  { id: 9, image: amazonLogo, title: "Amazon ₹250 gift card", cost: 2500 },
  { id: 10, image: flipkartLogo, title: "Flipkart ₹150 gift card", cost: 2500 },
];

const historyData: HistoryItem[] = [
  {
    brand: "Amazon",
    logo: amazonLogo,
    date: "12/6/2024",
    time: "12:05 PM",
    points: -250,
  },
  {
    brand: "Flipkart",
    logo: flipkartLogo,
    date: "3/5/2024",
    time: "4:35 PM",
    points: -700,
  },
  {
    brand: "Boat",
    logo: boatLogo,
    date: "3/4/2024",
    time: "2:08 PM",
    points: -450,
  },
  {
    brand: "Lenskart",
    logo: lenskartLogo,
    date: "2/1/2024",
    time: "9:20 AM",
    points: -200,
  },
  {
    brand: "MamaEarth",
    logo: mamaearthLogo,
    date: "1/15/2024",
    time: "10:00 AM",
    points: -300,
  },
];

const RedeemHistory: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="redeem-history-container">
      <h1>Redeemed Vouchers</h1>
      <section className="deals-section">
        <div className="redeemed-deals-container">
          {redeemedDeals.map((deal, index) => (
            <div
              key={deal.id}
              className={`redeemed-deal-card ${
                index % 3 === 0
                  ? "green-card"
                  : index % 3 === 1
                  ? "purple-card"
                  : "blue-card"
              }`}
            >
              <img src={deal.image} alt={deal.title} />
              <p>{deal.title}</p>
              <span>for {deal.cost} points</span>
              <button
                className="redeemed-buy-btn"
                onClick={() => alert("View details coming soon!")}
              >
                View
              </button>
            </div>
          ))}
        </div>
      </section>
      <header className="redeem-history-header">
        {/* Optional back button, in case you need to go back to Rewards */}
      </header>

      <div className="history-list">
        {historyData.map((item, index) => (
          <div key={index} className="history-item">
            <div className="brand-info">
              <img src={item.logo} alt={item.brand} />
              <div>
                <h3>Redeemed through {item.brand}</h3>
                <p>
                  {item.date} &nbsp;|&nbsp; {item.time}
                </p>
              </div>
            </div>
            <div className="points">{item.points}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RedeemHistory;
